import React from 'react';
import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import { SnackbarProvider } from 'notistack';

import Root from './components/Root';

dayjs.locale('ru');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <SnackbarProvider maxSnack={6} autoHideDuration={6_000}>
            <Root />
        </SnackbarProvider>
    </React.StrictMode>,
);
